export default {
  downloadApp: {
    id: 'app_store_download_banner_single_button_text',
    defaultMessage: 'Download app',
  },
  downloadAppQrCodeImage: {
    id: 'app_store_download_banner_qr_code_image',
    defaultMessage: 'App Download QR Code',
  },
  downloadAppBrandImage: {
    id: 'app_store_download_banner_brand_image',
    defaultMessage: 'BackMarket logo',
  },
  downloadAppGenericPhoneImage: {
    id: 'app_store_download_banner_generic_phone_image',
    defaultMessage: 'Generic image of a phone',
  },
  ratingValue: {
    id: 'app_download_rating',
    defaultMessage: '4.6',
  },
  ratingMessage: {
    id: 'app_download_rating_message',
    defaultMessage: 'join over 10M customers',
  },
  closeLabel: {
    id: 'app_download_close_label',
    defaultMessage: 'Close',
  },
  appStoreDownloadBannerFavoritesTitle: {
    id: 'app_download_favorites_title',
    defaultMessage: 'Follow deals on your favorites in the app',
  },
  appStoreDownloadBannerBuybackTitle: {
    id: 'app_download_buyback_title',
    defaultMessage: 'Our fastest trade-in offer ever',
  },
  appStoreDownloadBannerBuybackMobileTitle: {
    id: 'app_download_buyback_mobile_title',
    defaultMessage: 'Get offers faster in the app',
  },
  appStoreDownloadBannerBuybackSubtitle: {
    id: 'app_download_buyback_subtitle',
    defaultMessage:
      'Let AI do the work for you and get your estimate in seconds.',
  },
  appStoreDownloadBannerDefaultTitle: {
    id: 'app_download_default_title',
    defaultMessage: 'Deals so fast, only you see them',
  },
  appStoreDownloadBannerDefaultMobileTitle: {
    id: 'app_download_default_mobile_title',
    defaultMessage: 'Keep your tech in great shape on the app.',
  },
  appStoreDownloadBannerDefaultSubtitle: {
    id: 'app_download_default_subtitle',
    defaultMessage: 'Get there first when exclusive deals drop on the app.',
  },
  appStoreDownloadBannerProductListTitle: {
    id: 'app_download_product_list_title',
    defaultMessage: 'Never miss deals',
  },
  appStoreDownloadBannerProductListMobileTitle: {
    id: 'app_download_product_list_mobile_title',
    defaultMessage: 'Don’t miss flash sales on the app.',
  },
  appStoreDownloadBannerProductListSubtitle: {
    id: 'app_download_product_list_subtitle',
    defaultMessage: 'Get the app for early access to Flash Sales.',
  },
  appStoreDownloadBannerTradeInConfirmationTitle: {
    id: 'app_download_trade_in_confirmation_title',
    defaultMessage: 'Track your cash in the app',
  },
  appStoreDownloadBannerTradeInConfirmationSubtitle: {
    id: 'app_download_trade_in_confirmation_subtitle',
    defaultMessage: 'Keep tabs on your payment in real time.',
  },
  appStoreDownloadBannerPaymentConfirmationTitle: {
    id: 'app_download_payment_confirmation_title',
    defaultMessage: 'Track this order on the app',
  },
  appStoreDownloadBannerPaymentConfirmationSubtitle: {
    id: 'app_download_payment_confirmation_subtitle',
    defaultMessage: 'Keep tabs on when it arrives.',
  },
}
